import React, { useState, useEffect } from "react";
import QuestionTitle from "../QuestionTitle";
import DifferenceImages from "./DifferenceImages";
import { useSelector, useDispatch } from "react-redux";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";

export default function DifferenceQuestion() {
  const dispatch = useDispatch();
  const { currentQuestion, rightAnswer } = useSelector(({ quiz }) => quiz);
  const [pointes, setPointes] = useState([]);

  useEffect(() => {
    if (rightAnswer) {
      setPointes(rightAnswer);
    }
  }, [rightAnswer]);

  useEffect(() => {
    if (currentQuestion) {
      dispatch(
        setQuestionAnswer({
          questionId: currentQuestion._id,
          userOptionsDifferenceAnswer: pointes,
        })
      );
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [pointes, currentQuestion, dispatch]);

  return (
    <div className="w-100">
      <QuestionTitle title={currentQuestion?.title} noImg />
      {currentQuestion && (
        <DifferenceImages
          firstImg={currentQuestion.optionsDifferenceImage1}
          secondImg={currentQuestion.optionsDifferenceImage2}
          pointsLength={currentQuestion.optionsDifference.length}
          rightAnswer={rightAnswer}
          setMarker={(markers) => {
            setPointes(markers);
          }}
        />
      )}
    </div>
  );
}
